






































































































































































































































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsPaginator from "@/design-system/components/Paginator/JdsPaginator.vue"
import JdsField from "@/design-system/components/Field/JdsField.vue"
import JdsFieldRow from "@/design-system/components/Field/JdsFieldRow.vue"
import JdiCodeBlock from "@/components/JdiCodeBlock.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import DummyCounter from "@/content/DummyCounter.vue"
@Component({
    components: {
        DummyCounter,
        JdiStatus,
        JdiCodeBlock,
        JdsFieldRow, JdsFieldset: JdsField, JdsPaginator, JdiPreview, JdiContent}
})
export default class Paginator extends Vue {

    @Prop() mode!: 'full'|'arrows';

    interactiveCurrentPage = 1;
    interactivePages = 10;
    page = 1; // unused, just for the prop table explanation

    paginator(page: number) {
        return { ...this.$route, query: { ...this.$route.query, page, random: Math.floor(Math.random()*100) } }
    }

    mounted (){
        if (!this.$route.query.page) {
            this.$router.replace({ query: {page: '1'} })
        }
    }

}
